import axios from "axios";

const API_URL = "http://localhost:5000/api";

export const predictStress = async (inputValues) => {
    const response = await axios.post(`${API_URL}/predict-stress`, inputValues);
    return response.data;
};
